/* eslint-disable react/function-component-definition */
import React, { ReactNode } from 'react'
import { Tooltip } from 'antd'

type TooltipsProps = {
  icon?: ReactNode
  text: string
}

const Tooltips = ({ icon, text }: TooltipsProps) => (
  <Tooltip title={text}>
    <span>{icon}</span>
  </Tooltip>
)

export default Tooltips
